import { Heading, Fineprint } from '@flixbus/honeycomb-react';

import styles from './voucher-info.module.scss';
import { ReactElement, ReactNode } from 'react';

export interface InfoDisplayProps {
  title?: string | ReactElement;
  fields: {
    label?: string;
    value: ReactElement | string | null | undefined;
    skipBoldWrapper?: boolean;
  }[];
  message?: { icon: ReactElement; value: string } | null | undefined;
  // columns: title on the left, values on the right. stacked: title above the values.
  // nested: a stacked sub-section inside another stacked section.
  layout?: 'columns' | 'stacked' | 'nested';
  children?: ReactNode;
}

const InfoDisplay = ({
  title,
  fields,
  message,
  layout = 'columns',
  children,
}: InfoDisplayProps) => {
  return (
    <div className={layout === 'columns' ? undefined : styles[layout]}>
      <div className={styles.infoDisplay}>
        <Heading flushSpace extraClasses={styles.title} size={layout === 'nested' ? 4 : 3}>
          {title}
        </Heading>
        <div>
          {fields.map((f, i) => {
            if (!f.value) return null;

            return (
              <div className={styles.values} key={i}>
                {f.label && <label className={styles.label}>{f.label}</label>}
                {f.skipBoldWrapper ? (
                  <div className={styles.value}>{f.value}</div>
                ) : (
                  <strong className={styles.value}>{f.value}</strong>
                )}
              </div>
            );
          })}
          {message && (
            <div className={styles.values}>
              {message.icon}
              <Fineprint className={styles.messageText}>{message.value}</Fineprint>
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

export default InfoDisplay;
